<template>
  <div>
    <Loader :loading="loading" />
    <v-layout v-if="products.length" justify-center wrap>
      <v-flex md12>
        <v-data-table :headers="headers" :items="products" hide-actions>
          <template slot="headerCell" slot-scope="{ header }">
            <span
              class="subheading font-weight-light text-success text--darken-3"
              v-text="header.text"
            />
          </template>

          <template slot="items" slot-scope="{ item }">
             <td class="text-xs-left">
              <b>{{ item.activations.id +'/' + item.id }}</b> 
            </td>
            <td class="text-xs-left">
              <b>{{ item.serial_number }}</b>
            </td>
            <td class="text-xs-left">
              <b>{{ item.activations.reward | numberWithSpaces }}</b> сум
            </td>
            <td class="text-xs-left">
              <b>{{ item.activations.created_at | dateTime }}</b>
            </td>
          
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Loader from "../../helper/Loader";

export default {
  data: () => ({
    products: [],
    vendor_codes: [],
    participant: {},
    loading: true,
    findLoading: false,
    headers: [
      {
        sortable: false,
        text: "Тразакция",
        value: "dealer.id",
      },
      {
        sortable: false,
        text: "Серийный номер",
        value: "dealer.name",
      },
      {
        sortable: false,
        text: "Начислено",
        value: "dealer.options_count",
      },
      {
        sortable: false,
        text: "Дата активации",
        value: "dealer.name",
      },
    ],
  }),
  components: { Loader },
  methods: {
    getProducts() {
      axios
        .get("admin/tournaments/serials/" + this.Tournament_id, {
          params: {
            dealer_id: this.dealer_id,
            product_id: this.product_id,
          },
        })
        .then((response) => {
          this.products = response.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 400);
        });
    },
  },
  computed: {
    Tournament_id: {
      get() {
        return this.TournamentID;
      },
      set(val) {},
    },
    dealer_id: {
      get() {
        return this.dealerID;
      },
      set(val) {},
    },
    product_id: {
      get() {
        return this.productID;
      },
      set(val) {},
    },
  },
  mounted() {
    this.getProducts();
  },
  props: ["TournamentID", "dealerID", "productID"],
  // watch:{
  //   dealer_id(val){
  //     if (val){
  //       this.loading = true;
  //        this.getProducts();
  //     }
  //   }
  // }
};
</script>
